import { useState } from 'react';
import { METHODOLOGY } from '@/mocks/compare';
import { SectionHeading } from './ui';

export default function MethodologySection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Phương pháp"
        title="Công thức và phương pháp tính"
        subtitle="Tóm tắt các công thức đằng sau các công cụ so sánh."
      />

      <div className="mt-6 grid grid-cols-1 gap-3 md:grid-cols-2">
        {METHODOLOGY.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.title} className="overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-50/50">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center gap-3 px-5 py-4 text-left"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-50 text-violet-600">
                  <i className={f.icon} />
                </span>
                <span className="flex-1 text-sm font-bold text-slate-800">{f.title}</span>
                <i className={`ri-arrow-down-s-line text-lg text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
              </button>
              {isOpen && (
                <div className="border-t border-slate-200/70 px-5 py-4">
                  <p className="font-mono text-sm font-semibold text-violet-700">{f.formula}</p>
                  <p className="mt-2 text-xs leading-relaxed text-slate-500">{f.desc}</p>

                  {f.symbols && f.symbols.length > 0 && (
                    <div className="mt-4 border-t border-slate-200/70 pt-3">
                      <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Ký hiệu</p>
                      <div className="mt-2 flex flex-wrap gap-2">
                        {f.symbols.map((s) => (
                          <span
                            key={s.sym}
                            className="inline-flex items-center gap-1.5 rounded-lg bg-white px-2.5 py-1.5 text-[11px] ring-1 ring-slate-200/80"
                          >
                            <span className="font-mono font-semibold text-violet-600">{s.sym}</span>
                            <span className="text-slate-500">{s.meaning}</span>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}